import { Button, FormLabel, FormRow, Input } from '@components/ui';
import { useApi } from '@data-access';
import { ErrorHelper } from '@helpers';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import styles from './AddReportTypeForm.module.scss';

interface AddInsightfulnessCriteriaFormProps {
  closeModal: () => void;
  onInsightfulnessCriteriaCreated?: () => void;
}

export const AddInsightfulnessCriteriaForm: React.FC<AddInsightfulnessCriteriaFormProps> = ({
  closeModal,
  onInsightfulnessCriteriaCreated,
}) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const { api } = useApi();

  const onFormSubmit = handleSubmit(async formData => {
    try {
      await api.apiInsightfulnessCriteriaCreate({
        insightfulnessCriterion: {
          name: formData.name,
          definition: formData.definition,
          example: formData.example,
        },
      });
      closeModal();
      onInsightfulnessCriteriaCreated?.();
      toast.success('Successfully added insightfulness criteria', { autoClose: 6000 });
    } catch (error) {
      ErrorHelper.handleErrorNotification(error);
    }
  });

  return (
    <div className={styles.form}>
      <div className={styles.field}>
        <FormRow>
          <FormLabel
            id="name"
            className={styles.label}
          >
            <div>Name</div>
          </FormLabel>
          <Input
            props={{ ...register('name', { required: 'Please enter name' }) }}
            error={errors.name?.message as string}
            className={styles.select}
          />
        </FormRow>
        <FormRow>
          <FormLabel
            id="definition"
            className={styles.label}
          >
            <div>Definition</div>
          </FormLabel>
          <Input
            props={{ ...register('definition', { required: 'Please enter definition' }) }}
            error={errors.definition?.message as string}
            className={styles.select}
          />
        </FormRow>
        <FormRow>
          <FormLabel
            id="name"
            className={styles.label}
          >
            <div>Example</div>
          </FormLabel>
          <Input
            props={{ ...register('example', { required: 'Please enter example' }) }}
            error={errors.example?.message as string}
            className={styles.select}
          />
        </FormRow>
      </div>

      <div className={styles.buttons}>
        <Button
          type="button"
          onClick={onFormSubmit}
        >
          Add
        </Button>
      </div>
    </div>
  );
};
